// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@guestsupply/XDL/types";
import color from "@guestsupply/XDL/Utilities/color";
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            color: "text.main",
            ellipsis: true,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 21px;
                max-width: 100ch;
                &&& {
                    margin: 0;
                }
                ${IconWrapper} {
                    color: inherit;
                    vertical-align: middle;
                    height: fit-content;
                    width: 100%;
                    & > svg {
                        height: 21px;
                        width: 7px;
                    }
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            margin-top: 12px;
            gap: 8px;
            ${StyledButton} {
                position: relative;
                overflow: hidden;
            }
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("text.main")};
            }

            ${StyledButton}:hover > ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
            & > ${TypographyStyle} {
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 16px;
            }
            @media print {
                display: none;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
